import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { FC } from 'react';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import Image from 'next/image';
import { AboutUsHeading } from 'src/modules/about-us/components/shared/AboutUsHeading';
import { media } from 'src/styles/designs';
import { AboutUsSection } from 'src/modules/about-us/components/shared/AboutUsSection';
import { AboutUsContactButton } from 'src/modules/about-us/components/shared/AboutUsContactButton';
import aboutUsModelsImage from 'src/modules/about-us/assets/models.jpg';
import { dirRTL } from 'src/styles/theme';

const Description = styled.div`
  margin: 19px 0 35px;
  width: 198px;

  ${media.w.greaterThanOrEqual.desktop} {
    width: 304px;
    margin: 32px 0;
  }
  ${media.w.lessThan.desktop} {
    min-height: 174px;
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  right: 0;
  top: -30px;
  ${dirRTL} {
    left: 0;
    right: auto;
  }

  ${media.w.greaterThanOrEqual.desktop} {
    position: relative;
    bottom: 40px;
  }
`;

const ImageContainer = styled.div`
  position: relative;
  width: 136px;
  height: 294px;

  ${media.w.greaterThanOrEqual.desktop} {
    width: 379px;
    height: 601px;
  }
`;

const Container = styled(AboutUsSection)`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;

  ${media.w.greaterThanOrEqual.desktop} {
    justify-content: center;
  }
`;

const StyledImage = styled(Image)`
  object-fit: cover;
  object-position: 70% center;
`;

const StyledHeading = styled(AboutUsHeading)`
  width: 198px;

  ${media.w.greaterThanOrEqual.desktop} {
    width: 304px;
  }
`;

const TextContent = styled.div`
  display: flex;
  flex-direction: column;

  ${media.w.lessThan.desktop} {
    width: 100%;
    margin-top: 35px;
  }

  ${media.w.greaterThanOrEqual.desktop} {
    position: relative;
    margin: 0 177px 0 0;
    ${dirRTL} {
      margin: 0 0 0 177px;
    }
  }
`;

export const AboutUsHolisticVision: FC = () => {
  const { _ } = useTranslate();

  return (
    <Container>
      <TextContent>
        <StyledHeading>
          <Markdown>{_('ABOUT NEAUVIA CHANNEL')}</Markdown>
        </StyledHeading>
        <Description>
          <p>
            <Markdown>
              {_(
                'On this platform you will find all NEAUVIA scientific on-line trainings and exclusive Prime Time Talk Show. You also have the possibility to chat with NEAUVIA Experts via the CONTACT US section.',
              )}
            </Markdown>
          </p>
        </Description>
        <AboutUsContactButton />
      </TextContent>
      <ImageWrapper>
        <ImageContainer>
          <StyledImage src={aboutUsModelsImage} layout="fill" />
        </ImageContainer>
      </ImageWrapper>
    </Container>
  );
};
